import React from "react";
import {
  AppLayoutBase,
  Block,
  Button,
  Card,
  Col,
  MenuItemProps,
  Row,
} from "@mc/ui-v4";
import { getNavbarProps } from "../utils";

type Props = {
  currentKey?: string;
};

export const BaseLayoutWrapper: React.FC<Props> = ({
  children,
  currentKey,
}) => {
  return (
    <AppLayoutBase className={"w-100"} navbar={getNavbarProps(currentKey)}>
      {children}
    </AppLayoutBase>
  );
};
